import { REQUEST_STATUS } from '../constants'

export const defaultListState = {
  requestStatus: REQUEST_STATUS.NotRequested,
  lastFetched: 0,
  data: []
}

export const MAX_CACHE_AGE = 60 * 1000 * 1000
